import { useTheme } from '@mui/system';
import IconButton from '@mui/material/IconButton';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';

export const ColorModeToggle = ({ toggleColorMode }: { toggleColorMode: () => void }) => {
  const theme = useTheme();
  return (
    <IconButton sx={{ ml: 1 }} onClick={toggleColorMode} color='inherit'>
      {theme.palette.mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
    </IconButton>
  );
};
